import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid } from "@material-ui/core";
import Item from "./ratingScale/item";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useRatingScales from "./useRatingScales";

const RatingScales = ({ history }) => {

  const {
    color,
    data,
    isLoading,
    typeList,
    targetList,
    createRatingScaleIsOpen,
    setCreateRatingScaleIsOpen,
  } = useRatingScales();

  const customItems = (
    <>
      <CustomIconButton
        title={getLocalizedString("goBack")}
        onClick={() => history.push(paths.performanceDefinition)}
        type={"goBack"}
      />
    </>
  )

  const ratingScaleNames = data?.map(ratingScale => ratingScale.name) || [];
  const ratingScaleCodes = data?.map(ratingScale => ratingScale.code) || [];

  const getDataIsEmpty = () => {
    return !data || data.length === 0;
  }

  return (
    <ABMLayout
      title={getLocalizedString("ratingScales")}
      isLoading={isLoading}
      showCreateButton={!createRatingScaleIsOpen}
      createButtonTitle={getLocalizedString("newScaleType")}
      createButtonOnClick={() => setCreateRatingScaleIsOpen(true)}
      customItems={[customItems]}
      useCustomItemsEnd
      showNoData={getDataIsEmpty()}
      noDataTitle={getLocalizedString("noScaleTypesFound")}
      noDataCreateTitle={getLocalizedString("newScaleType")}
      noDataOnClick={() => setCreateRatingScaleIsOpen(true)}
    >
      {
        createRatingScaleIsOpen &&
        <Grid container item xs={12} style={{ margin: "10px 0px" }}>
          <Item
            data={null}
            color={color}
            closeNewRatingScale={() => setCreateRatingScaleIsOpen(false)}
            isLoading={isLoading}
            ratingScaleNames={ratingScaleNames}
            ratingScaleCodes={ratingScaleCodes}
            typeList={typeList}
            targetList={targetList}
          />
        </Grid>
      }
      {
        data.map((item) =>
          <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
            <Item
              data={item}
              color={color}
              isLoading={isLoading}
              ratingScaleNames={ratingScaleNames}
              ratingScaleCodes={ratingScaleCodes}
              typeList={typeList}
              targetList={targetList}
            />
          </Grid>
        )
      }
    </ABMLayout>
  )
}

export default RatingScales;